import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Heroku, mongo, node.js - a problem",
  "description": "",
  "published": "2012-01-30T00:00:00.000Z",
  "redirect_from": ["/blog/heroku-mongo-node-js-a-problem/swizec/3565"],
  "categories": "Heroku, JavaScript, JSON, MongoDB, Node.js, NoSQL, Programming, Ruby, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A couple facts about three cool technologies`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/300px-The_Hunt_of_the_Unicorn_Tapestry_71.jpg",
        "alt": "The Unicorn Is Penned, Unicorn Tapestries, c. ...",
        "title": "The Unicorn Is Penned, Unicorn Tapestries, c. ..."
      }}></img></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://nodejs.org/",
          "title": "Node.js"
        }}>{`node.js`}</a>{` is a powerful way of writing backend code in `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/JavaScript",
          "title": "JavaScript"
        }}>{`JavaScript`}</a>{`; why JavaScript? Because you have the kind of problem that benefits from asynchronous code (the average web app) and you like using the same brain for backend and frontend work`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.mongodb.org/",
          "title": "MongoDB"
        }}>{`mongoDB`}</a>{` is an awesome `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/NoSQL",
          "title": "NoSQL"
        }}>{`NoSQL`}</a>{` data store for objects. It is an especially great companion to JavaScript since its internal storage are `}<a parentName="li" {...{
          "href": "http://json.org/",
          "title": "JSON"
        }}>{`JSON`}</a>{`-objects. JSON has plays particularly well with JavaScript due to certain similarities (some even think the JSON language is a subset of JavaScript, `}<a parentName="li" {...{
          "href": "http://timelessrepo.com/json-isnt-a-javascript-subset",
          "title": "JSON: The JavaScript subset that isn't"
        }}>{`although it's not`}</a>{`)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.heroku.com/",
          "title": "Heroku"
        }}>{`Heroku`}</a>{` is the simplest way to deploy web apps. Originally designed for Ruby, it gained node.js support last spring/summer. There are `}<a parentName="li" {...{
          "href": "http://www.joyent.com/"
        }}>{`alternatives`}</a>{`, but heroku presents itself as a particularly good pick for various reasons (it `}<em parentName="li">{`feels`}</em>{` right)`}</li>
    </ul>
    <p>{`Combining these three technologies should be a walk in the park. `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Sliced_bread",
        "title": "Sliced bread"
      }}>{`The best thing since sliced bread`}</a>{` and unicorn farts should rain down the heavens upon you for even thinking of using node.js, mongo and heroku in unison.`}</p>
    <h2 {...{
      "id": "not-so-much"
    }}>{`Not so much.`}</h2>
    <p>{`The culprit - the bleeding edge, baby!`}</p>
    <p>{`Mongo's only been widely-ish popular for a year, node.js still isn't widely and Heroku is traditionally a `}<a parentName="p" {...{
        "href": "http://rubyonrails.org",
        "title": "Ruby on Rails"
      }}>{`RoR`}</a>{` hosting environment so there are things that aren't quite smooth yet.`}</p>
    <p>{`Getting mongoDB support on Heroku means using an external party - what heroku calls an add-on - `}<a parentName="p" {...{
        "href": "https://mongohq.com/home"
      }}>{`MongoHQ`}</a>{`. It's a mongoDB hosting provider that gives you access to a database and lets you loose.`}</p>
    <p>{`But MongoHQ requires authentication.`}</p>
    <p>{`My favourite mongoDB driver for node.js ... doesn't support authentication. At least it doesn't support authentication easily, in fact it doesn't support authentication so much that it isn't officially documented. The only reference to getting this working is `}<a parentName="p" {...{
        "href": "http://j-query.blogspot.com/2011/04/mongohq-and-node.html"
      }}>{`some guy's blogpost from April 2011`}</a>{`. This is an actively developed library by the way, the last commit to `}<a parentName="p" {...{
        "href": "https://github.com/christkv/node-mongodb-native"
      }}>{`node-mongodb-native`}</a>{`'s github was yesterday.`}</p>
    <p>{`Some say I should be using `}<a parentName="p" {...{
        "href": "https://github.com/LearnBoost/mongoose"
      }}>{`mongoose`}</a>{` instead, but that would most likely require rewriting the whole application at this point. Not to mention I don't like mongoose's `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Object-relational_mapping",
        "title": "Object-relational mapping"
      }}>{`ORM`}</a>{`-like approach because that's just a little too `}<a parentName="p" {...{
        "href": "http://www.iso.org/iso/catalogue_detail.htm?csnumber=45498",
        "title": "SQL"
      }}>{`SQL`}</a>{` for my liking. Why would you force a traditional data store way of doing things onto something as refreshing as Mongo?`}</p>
    <p>{`To make things worse, a while ago (about a year it seems), mongo introduced a new `}<a parentName="p" {...{
        "href": "http://www.mongodb.org/display/DOCS/Connections"
      }}>{`mongo:// url schema`}</a>{` for connecting to their database ... not even all the official drivers support it yet.`}</p>
    <p>{`Don't you just love the bleeding edge? Competing libraries, standards shifting under your feet and things never quite working out!`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//www.infoworld.com/d/application-development/nodejs-inventor-extends-javascript-programming-beyond-browsers-184963&a=72148407&rid=0ba152c5-e257-4f06-a4aa-d8c62e2e08c5&e=0cb31b66c2e367c75b2971631959db44"
        }}>{`Node.js inventor extends JavaScript programming beyond browsers`}</a>{` (infoworld.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.lukew.com/ff/entry.asp?1482"
        }}>{`The Four Horsemen of JavaScript`}</a>{` (lukew.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://nodemanual.org/latest/"
        }}>{`A community-driven manual for Node.js`}</a>{` (nodemanual.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://nosql.mypopescu.com/post/14453905385/attacking-nosql-and-node-js-server-side-javascript"
        }}>{`Attacking NoSQL and Node.js: Server-Side JavaScript Injection (SSJS)`}</a>{` (nosql.mypopescu.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/8904409/running-node-js-on-a-port-other-than-port-80"
        }}>{`Running node.js on a port other than port 80`}</a>{` (stackoverflow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://joyeur.com/2012/01/23/cloud9s-plans-for-node-js-community/"
        }}>{`Cloud9′s Plans for Node.js Community`}</a>{` (joyeur.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://hacks.mozilla.org/2012/01/javascript-on-the-server-growing-the-node-js-community/"
        }}>{`JavaScript on the server: Growing the Node.js Community`}</a>{` (hacks.mozilla.org)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=0ba152c5-e257-4f06-a4aa-d8c62e2e08c5",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      